type Webhook = {
  webhookName: string;
  endpointUrl: string;
  authRequired: boolean;
  authKey: string;
  authHeader: string;
  createdAt: number;
};

const WebhookEvent = {
  CAPTURE_EVENT: "captureEvent",
} as const;

type WebhookEvent = (typeof WebhookEvent)[keyof typeof WebhookEvent];

type NewWebhook = Omit<Webhook, "createdAt"> & {
  eventName: WebhookEvent;
};

export { Webhook, WebhookEvent, NewWebhook };
